import React from 'react';
import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';

export default function DocsContent({ section, prevSection, nextSection, onHeadingsChange }) {
    const headingRenderer = ({ node, children, ...props }) => {
        const text = String(children);
        const id = text
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .trim();

        const Tag = node.tagName;
        return (
            <Tag id={id} {...props}>
                {children}
            </Tag>
        );
    };

    const imageRenderer = ({ src, alt, ...props }) => (
        <img
            src={src}
            alt={alt || 'HFDX Documentation Diagram'}
            loading="lazy"
            {...props}
        />
    );

    return (
        <article className="docs_content">
            <header className="docs_content_header">
                <h1>{section.title}</h1>
            </header>

            <div className="docs_prose">
                <ReactMarkdown
                    remarkPlugins={[remarkGfm, remarkMath]}
                    rehypePlugins={[rehypeKatex]}
                    components={{
                        h2: headingRenderer,
                        h3: headingRenderer,
                        h4: headingRenderer,
                        img: imageRenderer,
                    }}
                >
                    {section.content}
                </ReactMarkdown>
            </div>

            <nav className="docs_nav">
                {prevSection && (
                    <Link
                        href={prevSection.slug === '' ? '/docs' : `/docs/${prevSection.slug}`}
                        className="docs_nav_link prev"
                    >
                        <span className="docs_nav_link_label">Previous</span>
                        <span className="docs_nav_link_title">{(prevSection.menuTitle || prevSection.title).split(' — ')[0]}</span>
                    </Link>
                )}
                {nextSection && (
                    <Link
                        href={nextSection.slug === '' ? '/docs' : `/docs/${nextSection.slug}`}
                        className="docs_nav_link next"
                    >
                        <span className="docs_nav_link_label">Next</span>
                        <span className="docs_nav_link_title">{(nextSection.menuTitle || nextSection.title).split(' — ')[0]}</span>
                    </Link>
                )}
            </nav>
        </article>
    );
}
